export class BasketService {
    constructor() {
        this._products = [];
    }
    set products(data) {
        this._products = data;
    }
    get products() {
        return this._products;
    }
    getProductCount() {
        return this.products.length;
    }
    getTotalPrice() {
        return this.products.reduce((total, product) => total + product.price, 0);
    }
    addProduct(product) {
        const isProductInBasket = this._products.some(p => p.id === product.id);
        if (!isProductInBasket) {
            this._products.push(product);
        }
    }
    removeProduct(product) {
        const index = this._products.indexOf(product);
        if (index >= 0) {
            this._products.splice(index, 1);
        }
    }
    clear() {
        this.products = [];
    }
}
